export default class Semester {
  constructor({
    id = null,
    name = '',
    start_date = '',
    end_date = '',
    copy_resources_from_last_semester = true,
    archived = false
  }) {
    this.id = id;
    this.name = name;
    this.start_date = start_date;
    this.end_date = end_date;
    this.copy_resources_from_last_semester = copy_resources_from_last_semester;
    this.archived = archived;
  }

  // Basic validation for semester data
  static validate(semesterData) {
    if (!semesterData.name) {
      throw new Error('Name is required');
    }
    if (!semesterData.start_date) {
      throw new Error('Start date is required');
    }
    if (!semesterData.end_date) {
      throw new Error('End date is required');
    }
    if (new Date(semesterData.start_date) >= new Date(semesterData.end_date)) {
      throw new Error('Start date must be before end date');
    }
    if (
      semesterData.copy_resources_from_last_semester === null ||
      semesterData.copy_resources_from_last_semester === undefined ||
      semesterData.copy_resources_from_last_semester === ''
    ) {
      throw new Error('copy_resources_from_last_semester is required and cannot be null or empty');
    }
    if (typeof semesterData.copy_resources_from_last_semester !== 'boolean') {
      throw new Error('copy_resources_from_last_semester must be a boolean');
    }
  }

  // Format like "29.1.2026" (unpadded D.M.YYYY), matching the app's house style.
  static formatDate(datetime) {
    if (!datetime) return '';
    const date = new Date(datetime);
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  // Parse a "D.M.YYYY" display string into ISO "YYYY-MM-DD" (the wire format).
  // Returns '' for empty/malformed/non-existent dates (e.g. 31.2.2026). Inverse of formatDate.
  static parseDisplayDate(text) {
    if (!text) return '';
    const parts = String(text).trim().split('.');
    if (parts.length !== 3) return '';
    const [d, m, y] = parts.map(p => Number(p.trim()));
    if (![d, m, y].every(Number.isInteger) || String(y).length !== 4) return '';
    const date = new Date(y, m - 1, d);
    if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return '';
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }

  static parseDates(semester) {
    return {
      ...semester,
      start_date: semester.start_date ? new Date(semester.start_date) : null,
      end_date: semester.end_date ? new Date(semester.end_date) : null
    };
  }
}
